module.exports = __webpack_public_path__ + "static/media/coins_1.ca7ee8db.webp";